import transakSDK from '@transak/transak-sdk'
import { config } from 'config'
import { useUser } from 'hooks/user/useUser'
import { useYoloToast } from 'lib/yoloToasts/useYoloToast'
import { useCallback } from 'react'

const TRANSAK_INIT = {
  //account
  apiKey: config.TRANSAK_APIKEY,
  environment: config.TRANSAK_ENVIRONMENT, // STAGING/PRODUCTION (Required)

  //crypto
  networks: 'polygon',
  cryptoCurrencyCode: 'USDC',
  defaultCryptoCurrency: 'USDC',
  cryptoCurrencyList: 'USDC',
  fiatCurrency: 'EUR',

  //flow
  redirectURL: 'https://www.yolorekt.finance/game', //'https://www.yolorekt.finance/game',
  hostURL: window.location.origin, // Required field

  //visuals
  widgetHeight: '667px',
  widgetWidth: '360px',
  themeColor: '2A6DFF',
  exchangeScreenTitle: 'YOLOREKT Deposit USDC',
}

const transakSuccesfullObj = {
  show: true,
  id: 'transakSuccessful',
}

export const useTransak = () => {
  const { account } = useUser('wallet')
  const { yToast } = useYoloToast()

  const initTransak = useCallback(
    (fiatAmount, walletAddress) => {
      const transak = new transakSDK({
        ...TRANSAK_INIT,
        fiatAmount,
        walletAddress: walletAddress || account,
      })
      transak.init()

      transak.on(transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData) => {
        yToast(transakSuccesfullObj)
        transak.close()
      })
    },
    [account, yToast]
  )

  return { initTransak }
}
